import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "../components/modules/SamplesTable/ui.helpers";

const SamplesUIContext = createContext();

export function useSamplesUIContext() {
  return useContext(SamplesUIContext);
}

export const SamplesUIConsumer = SamplesUIContext.Consumer;

export function SamplesUIProvider({ uiEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }
      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      return nextQueryParams;
    });
  }, []);

  const { openSampleDetailDialog } = uiEvents;

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openSampleDetailDialog,
  };

  return (
    <SamplesUIContext.Provider value={value}>
      {children}
    </SamplesUIContext.Provider>
  );
}
